import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ApiconfigComponent } from './apiconfig.component';
import { MaterialModuleMobi } from '../material/material.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MonacoEditorModule, MONACO_PATH } from '@materia-ui/ngx-monaco-editor';
import { FormArrayTemplateComponent } from './form-array-template/form-array-template.component';
import { AppPermissionsPipe } from '../shared_pipes/appPermissions.pipe';



@NgModule({
  declarations: [
    ApiconfigComponent,
    FormArrayTemplateComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MaterialModuleMobi,
    MonacoEditorModule,
    AppPermissionsPipe
  ],
  exports:[
    ApiconfigComponent
  ],
  providers: [{
		provide: MONACO_PATH,
		useValue: 'https://cdn.jsdelivr.net/npm/monaco-editor@0.48.0/min/vs'
	}],
})
export class ApiconfigModule { }
